import { useAppStore } from '@/stores'

export const pageSuccess = (success, severity = 'success') => {
  const appStore  = useAppStore();
  appStore.setIsPageLoading(false);
  // console.log("pageSuccess", success);
  var message = success && success.message;
  if (message) {
    appStore.notify({severity: severity, summary: message, life: 5000 })
  }
}

export const pageError = (error) => {
	const appStore  = useAppStore();
  appStore.setIsPageLoading(false);

  let errors;
  let title;

  if (error.response) {
    let data = error.response.data

    // In dev env data is string, in prod env data is object
    if (typeof data === 'string') {
      data = {errors: [error.response.statusText], message: 'Server Error'}
    }else if((typeof data === 'object') && data.error) {
      data = {errors: [data.detail], message: data.error || 'Server Error'}
    }

    errors = data && data.errors;
    title =  data && data.message;
  } else if (error != undefined) {
    errors = [error.message];
    title  = error.name;
  } else {
    errors = ['Errors'];
    title = "Page Error";
  }

  appStore.notify({severity: 'error', summary: title, detail: errors.join(','), life: 3000 }) 
}